import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAccount } from '../contexts/AccountContext';
import type { ModuleKey, UserPermissionsResponse } from '../types/extranet-api.types';

interface RequirePermissionProps<M extends ModuleKey> {
  module: M;
  flag: keyof UserPermissionsResponse['modules'][M];
  /** Vers où rediriger si pas de droit (défaut: '/') */
  fallback?: string;
  children: ReactNode;
}

export const RequirePermission = <M extends ModuleKey>({
  module,
  flag,
  fallback = '/',
  children,
}: RequirePermissionProps<M>) => {
  const { can } = useAccount();
  if (!can(module, flag)) return <Navigate to={fallback} replace />;
  return <>{children}</>;
};
